module.exports = __webpack_public_path__ + "img/cn.4abb1518.jpg";